/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Intake_Sex_NoteInputs */

const en_us2_body_assessment_intake_sex_note = /** @type {(inputs: Body_Assessment_Intake_Sex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The equation has a term for this and only takes two values. Your answer is used for this estimate alone and does not change your profile.`)
};

const pt_br2_body_assessment_intake_sex_note = /** @type {(inputs: Body_Assessment_Intake_Sex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A equação tem um termo para isso e só aceita dois valores. A sua resposta vale só para esta estimativa e não muda o seu perfil.`)
};

const es_419_body_assessment_intake_sex_note = /** @type {(inputs: Body_Assessment_Intake_Sex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ecuación tiene un término para esto y solo acepta dos valores. Tu respuesta se usa solo para esta estimación y no cambia tu perfil.`)
};

const pt_pt2_body_assessment_intake_sex_note = /** @type {(inputs: Body_Assessment_Intake_Sex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A equação tem um termo para isto e só aceita dois valores. A tua resposta vale apenas para esta estimativa e não altera o teu perfil.`)
};

const fr_fr2_body_assessment_intake_sex_note = /** @type {(inputs: Body_Assessment_Intake_Sex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'équation a un terme pour cela et n'accepte que deux valeurs. Ta réponse ne sert qu'à cette estimation et ne modifie pas ton profil.`)
};

const de_de2_body_assessment_intake_sex_note = /** @type {(inputs: Body_Assessment_Intake_Sex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Gleichung hat dafür einen Term und kennt nur zwei Werte. Deine Antwort gilt nur für diese Schätzung und ändert dein Profil nicht.`)
};

const it_it2_body_assessment_intake_sex_note = /** @type {(inputs: Body_Assessment_Intake_Sex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'equazione ha un termine per questo e accetta solo due valori. La tua risposta vale solo per questa stima e non cambia il tuo profilo.`)
};

/**
* | output |
* | --- |
* | "The equation has a term for this and only takes two values. Your answer is used for this estimate alone and does not change your profile." |
*
* @param {Body_Assessment_Intake_Sex_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_intake_sex_note = /** @type {((inputs?: Body_Assessment_Intake_Sex_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Intake_Sex_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_intake_sex_note(inputs)
	if (locale === "es-419") return es_419_body_assessment_intake_sex_note(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_intake_sex_note(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_intake_sex_note(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_intake_sex_note(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_intake_sex_note(inputs)
	return en_us2_body_assessment_intake_sex_note(inputs)
});
export { body_assessment_intake_sex_note as "body-assessment.intake_sex_note" }